import React, {useContext, useEffect, useState} from "react";
import ReactDOM from "react-dom";
import { Modal, Form, Button } from "react-bootstrap";
import axios from "axios";

import API_ROUTE from "../../utils/apiRoute";
import {GlobalContext} from "../../GlobalState";

const EditFloorModal = ({
  isShowing,
  toggle,
  floorId,
  setTitleText,
  toggleActionFeedback,
  setIsActionCompleted,
}) => {

  const [validated, setValidated] = useState(false);

  const [floorNameDefault, setFloorNameDefault] = useState("");
  const [isActive, setIsActive] = useState(true);
  const nameRef = useState(React.createRef())[0];

  const [showImageUpload, setShowImageUpload] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);

  const { selectedSchoolCode } = useContext(GlobalContext);

  useEffect(() => {
    (async () => {
      if (floorId !== null) {
        await axios
          .get(`${API_ROUTE}floor/${floorId}/`, {
            withCredentials: true,
          })
          .then((res) => {
            const floorName = res.data.data.floorData.name;
            const isActive = res.data.data.floorData.isActive;
            setFloorNameDefault(floorName);
            setIsActive(isActive);
          })
          .catch((err) => alert(err));
      }
    })();
  }, [floorId]);

  const handleChange = (evt) => {
    setFloorNameDefault(evt.currentTarget.value);
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    const form = event.currentTarget;
    if (form.checkValidity() === true) {
      const dataToSend = {
        newFloorName: nameRef.current.value,
        isActive: isActive,
      };
      (async () => {
        await axios
          .patch(`${API_ROUTE}floor/${floorId}`, dataToSend, {
            withCredentials: true,
          })
          .then((res) => {
            setTitleText("Piso alterado com sucesso!");
            setIsActionCompleted(true);
            toggleActionFeedback();
            toggle();
          })
          .catch((err) => {
            if (err.response.data.message) {
              setTitleText(err.response.data.message);
            } else {
              setTitleText(
                "Algo inesperado aconteceu, tente novamente mais tarde!"
              );
            }
            setIsActionCompleted(false);
            toggleActionFeedback();
            toggle();
          });
      })();
    } else {
      event.stopPropagation();
    }
    setValidated(true);
  };

  const handleFileChange = (e) => {
    setSelectedFile(e.target.files[0]);
  };

  const handleImageUpload = async (e) => {
    e.preventDefault();
    if (!selectedFile) return;

    const formData = new FormData();
    formData.append("schoolCode", selectedSchoolCode);
    formData.append("img", selectedFile);

    try {
      await axios.patch(
          `${API_ROUTE}floor/${floorId}/img`,
          formData,
          {
            withCredentials: true,
          }
      );
      setShowImageUpload(false);
      setTitleText("Imagem do Piso alterado com sucesso!");
      setIsActionCompleted(true);
      toggleActionFeedback();
      toggle();
    } catch (err) {
      console.error("Error uploading image:", err);
      if (err.response.data.message) {
        setTitleText(err.response.data.message);
      } else {
        setTitleText(
            "Algo inesperado aconteceu, tente novamente mais tarde!"
        );
      }
      setIsActionCompleted(false);
      toggleActionFeedback();
      toggle();
    }
  };

  return isShowing
      ? ReactDOM.createPortal(
          <React.Fragment>
            <Modal
                show={isShowing}
                onHide={() => {
                  setValidated(false);
                  toggle();
                }}
            >
              <Form noValidate validated={validated} onSubmit={handleSubmit}>
                <Modal.Header closeButton>
                  <Modal.Title>Editar Piso</Modal.Title>
                </Modal.Header>

                <Modal.Body>
                  <Form.Group controlId="validationCustomName">
                    <Form.Label>Nome</Form.Label>
                    <Form.Control
                        required
                        type="text"
                        placeholder="Nome do Piso"
                        value={floorNameDefault}
                        onChange={handleChange}
                        ref={nameRef}
                    />
                    <Form.Control.Feedback type="invalid">
                      O piso precisa de um nome!
                    </Form.Control.Feedback>
                  </Form.Group>

                  <Form.Group
                      controlId="validationCustomIsActive"
                      className="mt-3"
                  >
                    <Form.Check
                        type="checkbox"
                        label="Ativo"
                        checked={isActive}
                        onChange={(e) => setIsActive(e.target.checked)}
                    />
                  </Form.Group>
                </Modal.Body>

                <Modal.Footer className="d-flex justify-content-between">
                  <Button
                      variant="info"
                      onClick={() => setShowImageUpload(true)}
                  >
                    Atualizar Imagem
                  </Button>
                  <div>
                    <Button variant="danger" onClick={toggle} style={{ marginRight: "10px" }}>
                      Cancelar
                    </Button>
                    <Button type="submit" variant="success">
                      Confirmar
                    </Button>
                  </div>
                </Modal.Footer>
              </Form>
            </Modal>

            <Modal show={showImageUpload} onHide={() => setShowImageUpload(false)}>
              <Form onSubmit={handleImageUpload} encType="multipart/form-data">
                <Modal.Header closeButton>
                  <Modal.Title>Upload de Imagem</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                  <Form.Group controlId="formFile">
                    <Form.Label>Escolha uma imagem</Form.Label>
                    <Form.Control
                        type="file"
                        name="img"
                        required
                        accept=".jpeg, .png"
                        onChange={handleFileChange}
                    />
                  </Form.Group>
                </Modal.Body>
                <Modal.Footer>
                  <Button variant="secondary" onClick={() => setShowImageUpload(false)}>
                    Fechar
                  </Button>
                  <Button variant="primary" type="submit">
                    Enviar
                  </Button>
                </Modal.Footer>
              </Form>
            </Modal>
          </React.Fragment>,
          document.body
      )
      : null;
};

export default EditFloorModal;
